import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 80vh;
	overflow-y: auto;
`;

export const InnerContainer = styled.div`
	display: flex;
	justify-content: space-evenly;
`;

export const FilterContainer = styled.div`
	flex: 0.2;
	margin-top: 50px;
	margin-left: 30px;
`;

export const Filters = styled.div`
	display: flex;
`;

export const FilterLabel = styled.span`
	color: #a4a4a6;
`;

export const BaselineSummary = styled.div`
	flex: 0.4;
	margin-top: 50px;
`;

export const SummaryTitle = styled.span`
	display: flex;
	font-weight: bold;
	text-transform: uppercase;
	.ap-icon {
		margin-left: 5px;
	}
`;

export const Status = styled.div`
	flex: 0.4;
	margin-top: 10px;
	color: ${props => props.Fcolor};
`;

export const StatusTitle = styled.span`
	font-weight: bold;
`;

export const ColumnContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin: 20px;
`;

export const Header = styled.div`
	width: 100%;
	background-color: #5cb335;
	color: white;
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	margin-bottom: 20px;
`;

export const HeaderSpan = styled.span`
	padding: 2px;
`;

export const RefreshSpan = styled.span`
	background-color: black;
	color: white;
	padding: 2px;
`;
export const KpiSqaureGridContainer = styled.div`
	display: grid;
	padding: 10px;
	grid-template-columns: repeat(${props => props.columns || 4}, 1fr);
	grid-template-rows: repeat(${props => props.rows || 1}, 1fr);
	height: ${props => props.height || '100%'};
	gap: 10px;
`;

export const StackFilterWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
  	justify-content: flex-start;
  	margin:10px 10px 10px 0;
  	> div {
		> div>div {
        border-radius: 0;
		}
  .ap-button-main {
    height: 32px;
  }
`;

export const SingleFilterWrapper = styled.div`
	padding: 5px;
`;
export const MultiSelectWrapper = styled.div`
	> div > div {
		border-radius: 0;
	}
	padding: 5px;
	margin: 10px 10px 10px 0;
`;

export const SectionFormLabel = styled.div`
	flex: 0 0 100%;
	font-size: 10px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
	text-align: left;
	color: ${colors.grey5};
	margin-bottom: 4px;
`;

export const IconWrapper = styled.span`
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;
